import { PricingCard } from '@bq/web-components';
import styles from './PricingSection.module.css';

export interface PricingSectionProps {
  onSignUp?: () => void;
}

const betaPlanFeatures = [
  'Free account',
  'Digital Agile',
  'Future founding perks',
  'Personalized Learning',
  'Knowledge expert',
  'Basic Metrics',
  'Project specific AI',
  'Platform & tool integrations',
];

export function PricingSection({ onSignUp }: PricingSectionProps) {
  return (
    <section data-crd-id="r4.bq-pricing-section" data-crd-layer="r4" className={styles.section} id="pricing">
      <div className={styles.container}>
        <PricingCard
          planName="Beta Plan"
          subtitle="Become a Founding User!"
          price="$0"
          term="/mo"
          features={betaPlanFeatures}
          ctaLabel="Sign Up It's Free!"
          onCtaClick={onSignUp}
        />
      </div>
    </section>
  );
}
